import { apiSlice } from '@/shared/api/apiSlice'
import { ServerResponse } from '@/shared/types/common'

import { BONUS_CONVERSION_TITLE } from '../model/constants'

export type BonusConversionFormData = {
	NAME: string
	EMAIL: string
	PHONE: string
}

type PostBonusConversionFormPayload = {
	formData: BonusConversionFormData
	url: string
}

export const bonusConversionApi = apiSlice.injectEndpoints({
	endpoints: build => ({
		postBonusConversionForm: build.mutation<ServerResponse<unknown>, PostBonusConversionFormPayload>({
			query: ({ formData, url }) => ({
				url: `landing/special/register`,
				method: 'POST',
				params: {
					URL: url,
					TITLE: BONUS_CONVERSION_TITLE,
					IS_REGISTER: false,
					...formData
				}
			})
		})
	})
})

export const { usePostBonusConversionFormMutation } = bonusConversionApi
